@if (config.layout === 'simple') {
    <butterfly-footer-simple
        [logo]="{
            url: 'assets/header-logo-desktop.svg',
            link: { href: config.menu.siteRoot, title: '' },
        }"
        [footer]="config.footer"
        [socialMediaLinks]="config.socialMediaLinks"
        [culture]="culture">
    </butterfly-footer-simple>
} @else {
    <butterfly-footer
        [footer]="config.footer"
        [socialMediaLinks]="config.socialMediaLinks"
        [companyInfo]="config.companyInfo"
        [culture]="culture"></butterfly-footer>
}
